"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByRegister = exports.RegisterLabel = exports.getCopyKey = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("../");
var common_translations_1 = require("../common-translations");
var typography_1 = require("./typography");
/* The order of this list is used in sortRegisterOrder below */
var orderedLabelMap = {
    registerAnytime: ['Anytime', 'ANYTIME'],
    registerPeak: ['Day', 'Peak', 'PEAK'],
    registerShoulder: ['SHOULDER'],
    registerOffPeak: ['Night', 'OffPeak', 'Offpeak', 'OFF_PEAK', 'OFFPEAK'],
    registerEveningAndWeekend: ['EveningAndWeekend', 'Evening_and_weekend'],
    registerEvOffPeak: ['EVOffPeak', 'EVoffpeak', 'EV_OFF_PEAK', 'EV_OFFPEAK'],
    registerSuperOffPeak: ['SuperOffPeak', 'SUPER_OFF_PEAK', 'SUPER_OFFPEAK'],
    registerInterval: ['Interval'],
    registerHeating: ['Heating'],
    registerControlledLoad: ['Controlled Load'],
    registerSolar: ['Solar', 'SOLAR'],
};
var getCopyKey = function (friendlyLabel) {
    // Object.entries does not preserve the key type, but we know what it is.
    return Object.entries(orderedLabelMap).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return value.includes(friendlyLabel) ? key : acc;
    }, null);
};
exports.getCopyKey = getCopyKey;
exports.RegisterLabel = (0, react_1.forwardRef)(function (_a, ref) {
    var friendlyLabel = _a.friendlyLabel, capitalise = _a.capitalise, rest = __rest(_a, ["friendlyLabel", "capitalise"]);
    var copy = (0, __1.useCopy)({
        keys: {
            registerAnytime: 'common.registerAnytime',
            registerPeak: 'common.registerPeak',
            registerOffPeak: 'common.registerOffPeak',
            registerEveningAndWeekend: 'common.registerEveningAndWeekend',
            registerSuperOffPeak: 'common.registerSuperOffPeak',
            registerEvOffPeak: 'common.registerEvOffPeak',
            registerHeating: 'common.registerHeating',
            registerSolar: 'common.registerSolar',
            registerInterval: 'common.registerInterval',
            registerShoulder: 'common.registerShoulder',
            registerControlledLoad: 'common.registerControlledLoad',
        },
        defaultTranslations: common_translations_1.translations,
    }).copy;
    var key = (0, exports.getCopyKey)(friendlyLabel);
    if (!key) {
        return null;
    }
    var copyLabel = copy(key);
    return (react_1.default.createElement("span", __assign({ "data-testid": "register-label" }, rest, { ref: ref }), capitalise ? (0, typography_1.capitalise)(copyLabel) : copyLabel));
});
var sortByRegister = function (list, keyFn) {
    var desiredOrderedList = Object.keys(orderedLabelMap);
    return __spreadArray([], __read(list), false).sort(function (a, b) {
        return !(0, exports.getCopyKey)(keyFn(a))
            ? 1
            : !(0, exports.getCopyKey)(keyFn(b))
                ? -1
                : desiredOrderedList.findIndex(function (item) { return item === (0, exports.getCopyKey)(keyFn(a)); }) >
                    desiredOrderedList.findIndex(function (item) { return item === (0, exports.getCopyKey)(keyFn(b)); })
                    ? 1
                    : -1;
    });
};
exports.sortByRegister = sortByRegister;
